import { inject, Injectable } from "@angular/core";
import { NotificationMessage } from "@api/model/notificationMessage";
import { VoltaAuthService } from "@core/auth/volta-auth.service";
import { VoltaCommon } from "@core/common/volta-common";
import * as signalR from '@microsoft/signalr';

@Injectable({
    providedIn: 'root'
})
export class ProcessRunnerNotificationApiHubService {

    private path = `${VoltaCommon.VOLTA_DOMAIN_API}/signalr/notifications`;
    readonly Connection;
    authService = inject(VoltaAuthService);

    constructor(){
        this.Connection = new signalR.HubConnectionBuilder()
        .withUrl(this.path, {
            accessTokenFactory: () => this.authService.getAccessToken() ?? ''
        })
        .withAutomaticReconnect()
        .build();
    }

    Hub = {

        ReceiveNotification: (action:(data:NotificationMessage) => any) => {
            this.Connection.on('ReceiveNotification', action);
        }

    }

}